// extracted by mini-css-extract-plugin
export default {"label":"ReturnOptions_label__wL++1","note":"ReturnOptions_note__pnRfx"};